import { local } from "@/request/http";

export const getMenuList = () =>
    local([
        {
            id: 1,
            path: "/manager/index",
            icon: "el-icon-message",
            alias: "实验列表"
        },
        {
            id: 4,
            path: "/manager/admin",
            icon: "el-icon-message",
            alias: "用户管理"
        },
        {
            id: 5,
            path: "/manager/expData",
            alias: "实验数据"
        },
        {
          id:7,
          alias: "新闻管理",
          path: "/manager/webNewsList"
        },
        {
          id:8,
          path: "/manager/webNoticeList",
          alias: "公告管理"
        },
        {
          id:9,
          alias: "案例管理",
          path: "/manager/CaseList"
        }

    ]);
